import { LinearProgress, styled } from '@mui/material'
import React from 'react'

export interface BarChartValues {
  5: number
  4: number
  3: number
  2: number
  1: number
}
interface BarProps {
  values: BarChartValues
}

const ReviewChart: React.FunctionComponent<BarProps> = ({ values }) => {
  const totalVotes: number = Object.values(values).reduce(
    (a: number, b: number) => Number(a + b),
    0,
  )

  return (
    <div className='mb-5 w-full items-center pr-5 text-iris'>
      <div className='mb-2 grid grid-cols-[21fr_74fr_5fr] md:grid-cols-[5fr_90fr_5fr] lg:grid-cols-[5fr_90fr_5fr] xl:grid-cols-[21fr_74fr_5fr] items-center'>
        <span className='Type-Largw-Regular flex items-center text-medium-dark-gray'>
          5<div className='md:hidden xl:block ml-1'>stars</div>
        </span>{' '}
        <LinearProgress
          className='mx-5'
          variant='determinate'
          value={(values[5] / totalVotes) * 100}
          sx={{
            height: '8px',
            background: '#d2c4e6',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#A95CFF',
            },
          }}
        />
        <span className='Type-XL-Regular lg:Type-XL-Regular inline w-[1.25rem] text-medium-dark-gray'>
          ({values[5]})
        </span>
      </div>
      <div className='mb-2 grid grid-cols-[21fr_74fr_5fr] md:grid-cols-[5fr_90fr_5fr] lg:grid-cols-[5fr_90fr_5fr] xl:grid-cols-[21fr_74fr_5fr] items-center'>
        <span className='Type-Largw-Regular flex items-center text-medium-dark-gray'>
          4<div className='md:hidden xl:block ml-1'>stars</div>
        </span>

        <LinearProgress
          className='mx-5'
          variant='determinate'
          value={(values[4] / totalVotes) * 100}
          sx={{
            height: '8px',
            background: '#d2c4e6',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#A95CFF',
            },
          }}
        />
        <span className='Type-XL-Regular lg:Type-XL-Regular inline w-[1.25rem] text-medium-dark-gray'>
          ({values[4]})
        </span>
      </div>
      <div className='mb-2 grid grid-cols-[21fr_74fr_5fr] md:grid-cols-[5fr_90fr_5fr] lg:grid-cols-[5fr_90fr_5fr] xl:grid-cols-[21fr_74fr_5fr] items-center'>
        <span className='Type-Largw-Regular flex items-center text-medium-dark-gray'>
          3<div className='md:hidden xl:block ml-1'>stars</div>
        </span>
        <LinearProgress
          className='mx-5'
          variant='determinate'
          value={(values[3] / totalVotes) * 100}
          sx={{
            height: '8px',
            background: '#d2c4e6',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#A95CFF',
            },
          }}
        />
        <span className='Type-XL-Regular lg:Type-XL-Regular inline w-[1.25rem] text-medium-dark-gray'>
          ({values[3]})
        </span>
      </div>
      <div className='mb-2 grid grid-cols-[21fr_74fr_5fr] md:grid-cols-[5fr_90fr_5fr] lg:grid-cols-[5fr_90fr_5fr] xl:grid-cols-[21fr_74fr_5fr] items-center'>
        <span className='Type-Largw-Regular flex items-center text-medium-dark-gray'>
          2<div className='md:hidden xl:block ml-1'>stars</div>
        </span>{' '}
        <LinearProgress
          className='mx-5'
          variant='determinate'
          value={(values[2] / totalVotes) * 100}
          sx={{
            height: '8px',
            background: '#d2c4e6',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#A95CFF',
            },
          }}
        />
        <span className='Type-XL-Regular lg:Type-XL-Regular inline w-[1.25rem] text-medium-dark-gray'>
          ({values[2]})
        </span>
      </div>
      <div className='mb-2 grid grid-cols-[21fr_74fr_5fr] md:grid-cols-[5fr_90fr_5fr] lg:grid-cols-[5fr_90fr_5fr] xl:grid-cols-[21fr_74fr_5fr] items-center'>
        <span className='Type-Largw-Regular flex items-center text-medium-dark-gray'>
          1<div className='md:hidden xl:block ml-1'>stars</div>
        </span>{' '}
        <LinearProgress
          className='mx-5'
          variant='determinate'
          value={(values[1] / totalVotes) * 100}
          sx={{
            height: '8px',
            background: '#d2c4e6',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#A95CFF',
            },
          }}
        />
        <span className='Type-XL-Regular lg:Type-XL-Regular inline w-[1.25rem] text-medium-dark-gray'>
          ({values[1]})
        </span>
      </div>
    </div>
  )
}
export default ReviewChart
